import changelogData from "../../../../../pages/rolling-stock/docs/developer-portal/developer-portal/changelog-rolling-stock.json5";
import * as React from 'react';
export default {
  changelogData,
  React
};